import {CanDeactivateFn} from '@angular/router';
import Swal from 'sweetalert2';

export interface CanComponentDeactivateWithPendingSave {
  flushPendingSave: () => Promise<'saved' | 'invalid' | 'failed'>;
  hasUnsavedChanges: () => boolean;
  changeToInvalidTab?: () => void;
}

// Awaits a flush of whatever save is pending or in flight, then only blocks navigation
// (with a Stay/Leave dialog) when changes are still unsaved afterwards -- a validation
// error, a server error, or an invalid share message, which the autosave debounce skips
// silently today. A /login target (session expiry, forced logout) always passes.
export const pendingSaveGuard: CanDeactivateFn<CanComponentDeactivateWithPendingSave> = async (
  component,
  _currentRoute,
  _currentState,
  nextState
) => {
  if (nextState?.url?.startsWith('/login')) {
    return true;
  }

  if (!component || typeof component.flushPendingSave !== 'function') {
    return true;
  }

  await component.flushPendingSave();

  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const result = await Swal.fire({
    title: 'You have unsaved changes. If you leave now, your changes will be lost.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Leave',
    cancelButtonText: 'Stay',
    width: '35%',
    allowOutsideClick: false,
    allowEscapeKey: false
  });

  if (result.value) {
    return true;
  }

  component.changeToInvalidTab?.();
  return false;
};
